document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header-wrapper');
    const utilityBar = document.querySelector('.utility-bar');
    if (!header || !utilityBar) return;
    const desktopSpacing = { initial: 28, min: 10 };
    const mobileSpacing = { initial: 14, min: 5 };
    function getSpacing() {
        return window.innerWidth <= 768 ? mobileSpacing : desktopSpacing;
    }
    function updateHeaderPosition() {
        const rect = utilityBar.getBoundingClientRect();
        const { initial, min } = getSpacing();
        let computedTop = rect.bottom + initial;
        if (computedTop < min) {
            computedTop = min;
        }
        header.style.top = computedTop + 'px';
    }
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                updateHeaderPosition();
                ticking = false;
            });
            ticking = true;
        }
    }
    window.addEventListener('resize', updateHeaderPosition);
    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeaderPosition();
});